<script >
import { onMounted, ref, provide } from 'vue-demi';
import useMain from './useMain';
import useModal from './useModal';
import useFetchActivityData from './useFetchActivityData';
import { REPORT_NAME } from '../common/constant';
// 容器相关
import ChildMain from '../children/main/render.vue';
import ChildModal from '../children/modal/render.vue';
import { CHILD_MAIN, CHILD_MODAL } from '../common/constant';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
const __sfc_main = {
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD_MAIN]: ChildMain,
    [CHILD_MODAL]: ChildModal
  })]
};
__sfc_main.props = ['tpl', 'market'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  /* 主模块 */
  const {
    main,
    setMainStatus
  } = useMain(props);

  /* 弹窗 */
  const {
    modal,
    setModalStatus,
    visible,
    modalStatus
  } = useModal(props);
  provide('visible', visible);
  provide('modalStatus', modalStatus);

  /* 活动数据 */
  const {
    receiveQuoteActivity: _receiveQuoteActivity
  } = useFetchActivityData(props, {
    setMainStatus,
    setModalStatus
  });

  // 上报
  const {
    ftReport
  } = window.FEGORender?.plugins;
  const quoteActivityRef = ref();
  onMounted(() => {
    ftReport.record({
      target: quoteActivityRef.value
    }, {
      $element_name: REPORT_NAME.MAIN_VIEW
    });
  });
  const receiveQuoteActivity = async () => {
    // 领取按钮上报
    ftReport.record({
      target: quoteActivityRef.value
    }, {
      $element_name: REPORT_NAME.MAIN_CLICK
    });
    await _receiveQuoteActivity();
  };

  /* 暴露给其他组件操作 */
  return Object.assign({
    main,
    modal,
    visible,
    quoteActivityRef
  }, {
    receiveQuoteActivity
  });
};
export default __sfc_main;
</script>

<template>
    <div ref="quoteActivityRef" class="quote-activity">
        <!-- 子项 -->
        <inner-children-renderer v-if="main" :children="main"></inner-children-renderer>
        <!-- 弹窗 -->
        <inner-children-renderer v-if="modal && visible" :children="modal"></inner-children-renderer>
    </div>
</template>
<style lang="less">
@import './common.less';
.quote-activity {
    height: auto !important;
}
</style>
<style lang="less">
@keyframes van-rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
.silky-loading .ui-indicator-flower {
    animation: van-rotate 0.8s linear infinite;
}
</style>
